import {
  CButton,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CInvalidFeedback,
  CLabel,
  CRow,
  CSelect,
  CSpinner,
  CTextarea,
} from "@coreui/react";
import React, { useState } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import { useHistory } from "react-router-dom";
import Auth from "src/auth";

const AddTender = () => {
  const { authenticated } = Auth();
  const history = useHistory();
  const year = 1900;

  const [loading, setloading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [tenderId, settenderId] = useState(0);
  const [tenderNo, settenderNo] = useState();
  const [details, setdetails] = useState();
  const [paymentSlots, setpaymentSlots] = useState(null);
  const [rebate, setrebate] = useState();
  const [lateFeePerDay, setlateFeePerDay] = useState();
  const [securityDepositAmount, setsecurityDepositAmount] = useState();
  const [securityDepositDay, setsecurityDepositDay] = useState();
  const [TenderType, setTenderTypes] = useState(null);
  const [purchaseDate, setpurchaseDate] = useState();
  // eslint-disable-next-line no-unused-vars
  const [totalLots, settotalLots] = useState();
  // eslint-disable-next-line no-unused-vars
  const [canModified, setcanModified] = useState();
  const [collectionSeason, setcollectionSeason] = useState(
    new Date().getFullYear()
  );
  const [leasePeriodDate, setleasePeriodDate] = useState();
  // eslint-disable-next-line no-unused-vars
  const [valid, setvalid] = useState();
  const [paymentDueDates1, setpaymentDueDates1] = useState();
  const [paymentDueDates2, setpaymentDueDates2] = useState();
  const [paymentDueDates3, setpaymentDueDates3] = useState();
  const [paymentDueDates4, setpaymentDueDates4] = useState();
  const [paymentDueDates5, setpaymentDueDates5] = useState();
  const [paymentDueComplete1, setpaymentDueComplete1] = useState();
  const [paymentDueComplete2, setpaymentDueComplete2] = useState();
  const [paymentDueComplete3, setpaymentDueComplete3] = useState();
  const [paymentDueComplete4, setpaymentDueComplete4] = useState();
  const [paymentDueComplete5, setpaymentDueComplete5] = useState();
  const [dueDates, setdueDates] = useState([]);
  const [paymentTermination1, setpaymentTermination1] = useState();
  const [paymentTermination2, setpaymentTermination2] = useState();
  const [paymentTermination3, setpaymentTermination3] = useState();
  const [paymentTermination4, setpaymentTermination4] = useState();
  const [paymentTermination5, setpaymentTermination5] = useState();
  //const [terminateDate, setterminateDate] = useState([]);
  const [clauseSlots, setclauseSlots] = useState(0);
  const [clausesData, setclausesData] = useState([]);
  const [clauseData, setclauseData] = useState();
  const [clauseId, setclauseId] = useState([]);
  const [godownInsuraceFromDate, setGodownInsuraceFromDate] = useState();
  const [godownInsuraceToDate, setGodownInsuraceToDate] = useState();
  const [
    lastDateForSubmittingInsurancePolicy,
    setLastDateForSubmittingInsurancePolicy,
  ] = useState();
  const [extraAmountInsuranceLastDate, setExtraAmountInsuranceLastDate] =
    useState();
  const [lateFeeInsuranceAmount, setLateFeeInsuranceAmount] = useState();
  const [penaltyAmount, setPenaltyAmount] = useState();
  const [TerminationAgreementStartDate, setTerminationAgreementStartDate] =
    useState();
  const [TerminationAgreementEndDate, setTerminationAgreementEndDate] =
    useState();
  const [AfterTerminationDate, setAfterTerminationDate] = useState();
  const [RestorationFee, setRestorationFee] = useState();
  const [TerminationUpToDate, setTerminationUpToDate] = useState();
  const [TerminationLateFeePerDay, setTerminationLateFeePerDay] = useState();
  const [PruningStartDate, setPruningStartDate] = useState();
  const [PruningEndDate, setPruningEndDate] = useState();
  const [AgreementStartDate, setAgreementStartDate] = useState();
  const [AgreementUptoDate, setAgreementUptoDate] = useState();
  const [ChequeReplacementLastDate, setChequeReplacementLastDate] = useState();
  const [FirstTransferLastDate, setFirstTransferLastDate] = useState();
  const [SecondTransferStartDate, setSecondTransferStartDate] = useState();
  const [SecondTransferEndDate, setSecondTransferEndDate] = useState();
  const [periodEndingDate, setperiodEndingDate] = useState();
  const [representativeDetailsLastDate, setrepresentativeDetailsLastDate] =
    useState();
  const [paymentLastDate, setpaymentLastDate] = useState();
  const [doubleLockUptoDate, setdoubleLockUptoDate] = useState();
  const [throughLetterDate, setthroughLetterDate] = useState();
  const [keepingInGodownDate, setkeepingInGodownDate] = useState();
  const [godownRentPaymentUptoDate, setgodownRentPaymentUptoDate] = useState();
  const [secondAgreementExtentionDate, setsecondAgreementExtentionDate] =
    useState();
  const [additionalSDLastDate, setadditionalSDLastDate] = useState();
  const [HSN, setHSN] = useState();
  const [godownRentPerBag, setGodownRentPerBag] = useState();
  let dueDatesArr = [];
  const postDisctData = async (e) => {
    e.preventDefault();
    const finalClause = [{ id: 0, clause: clauseData }, ...clausesData];
    const finalStringArr = finalClause.map((data) => data.clause);
    setloading(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "Tender/add",
      "POST",
      header,
      JSON.stringify({
        tenderId: Number(tenderId),
        tenderNo: tenderNo,
        details: details,
        rebate: rebate,
        purchaseDate: purchaseDate,
        lateFeePerDay: lateFeePerDay,
        securityDepositAmount: securityDepositAmount,
        securityDepositDay: securityDepositDay,
        canModified: canModified,
        paymentSlots: paymentSlots,
        paymentDueDates: dueDates,
        totalLots: totalLots,
        collectionSeason: collectionSeason,
        leasePeriodDate: leasePeriodDate,
        sanctionClauses: finalStringArr[0] === undefined ? [] : finalStringArr,
        godownInsuraceFromDate: godownInsuraceFromDate,
        godownInsuraceToDate: godownInsuraceToDate,
        lastDateForSubmittingInsurancePolicy:
          lastDateForSubmittingInsurancePolicy,
        extraAmountInsuranceLastDate: extraAmountInsuranceLastDate,
        lateFeeInsuranceAmount: lateFeeInsuranceAmount,
        penaltyAmount: penaltyAmount,
        terminationAgreementStartDate: TerminationAgreementStartDate,
        terminationAgreementEndDate: TerminationAgreementEndDate,
        afterTerminationDate: AfterTerminationDate,
        restorationFee: RestorationFee,
        terminationUpToDate: TerminationUpToDate,
        terminationLateFeePerDay: TerminationLateFeePerDay,
        pruningStartDate: PruningStartDate,
        pruningEndDate: PruningEndDate,
        agreementStartDate: AgreementStartDate,
        agreementUptoDate: AgreementUptoDate,
        periodEndingDate,
        representativeDetailsLastDate,
        paymentLastDate,
        doubleLockUptoDate,
        throughLetterDate,
        keepingInGodownDate,
        godownRentPaymentUptoDate,
        secondAgreementExtentionDate,
        additionalSDLastDate,
        godownRentPerBag,
        HSN,
        TenderType,
        ChequeReplacementLastDate,
        FirstTransferLastDate,
        SecondTransferStartDate,
        SecondTransferEndDate,
      })
    );

    const jsonobj = await response.json();
    if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
      setloading(false);
      const redirectURL =
        authenticated.role === "CGMF" ? "/tender/tenderlist" : "/tenderlist";
      history.push(redirectURL);
    } else {
      setvalid("please enter valid values");
      setloading(false);
    }
  };

  let one = (
    <CRow className="mb-3">
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment due dates 1
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={paymentDueDates1 === null ? " " : paymentDueDates1}
          onChange={(e) => {
            setpaymentDueDates1(e.target.value);
            if (dueDates.length !== 0) {
              dueDatesArr = dueDates;
              dueDatesArr[0].paymentDueDate = e.target.value;
            } else {
              dueDatesArr.push({
                paymentDueDate: e.target.value,
                paymentComplete:
                  paymentDueComplete1 === undefined ? 0 : paymentDueComplete1,
                terminationDate:
                  paymentTermination1 === undefined ? " " : paymentTermination1,
              });
            }

            setdueDates(dueDatesArr);

            // setdueDates([paymentDueDates1]);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment Complete
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          min="0"
          max="100"
          type="number"
          placeholder=""
          value={
            paymentDueComplete1 === null || paymentDueComplete1 === undefined
              ? null
              : paymentDueComplete1 > 100
              ? 100
              : paymentDueComplete1 < 0
              ? 0
              : paymentDueComplete1
          }
          onChange={(e) => {
            setpaymentDueComplete1(Number(e.target.value));

            if (dueDates.length !== 0) {
              dueDatesArr = dueDates;
              dueDatesArr[0].paymentComplete = Number(
                e.target.value > 100
                  ? 100
                  : e.target.value < 0
                  ? 0
                  : e.target.value
              );
            } else {
              dueDatesArr.push({
                paymentDueDate: paymentDueDates1,
                paymentComplete: Number(
                  e.target.value > 100
                    ? 100
                    : e.target.value < 0
                    ? 0
                    : e.target.value
                ),
                terminationDate:
                  paymentTermination1 === undefined ? " " : paymentTermination1,
              });
            }

            setdueDates(dueDatesArr);

            // setdueDates([paymentDueDates1]);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Terminate date 1
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={paymentTermination1 === null ? " " : paymentTermination1}
          onChange={(e) => {
            setpaymentTermination1(e.target.value);
            if (dueDates.length !== 0) {
              dueDatesArr = dueDates;
              dueDatesArr[0].terminationDate = e.target.value;
            } else {
              dueDatesArr.push({
                paymentDueDate: paymentDueDates1,
                paymentComplete:
                  paymentDueComplete1 === undefined ? 0 : paymentDueComplete1,
                terminationDate: e.target.value,
              });
            }

            setdueDates(dueDatesArr);

            // setdueDates([paymentDueDates1]);
          }}
        />
      </CCol>
    </CRow>
  );
  let two = (
    <CRow className="mb-3">
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment due date 2
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={paymentDueDates2 === null ? " " : paymentDueDates2}
          onChange={(e) => {
            setpaymentDueDates2(e.target.value);
            if (dueDates.length >= 2) {
              dueDatesArr = dueDates;
              dueDatesArr[1].paymentDueDate = e.target.value;
            } else {
              dueDatesArr.push(dueDates[0], {
                paymentDueDate: e.target.value,
                paymentComplete:
                  paymentDueComplete2 === undefined ? 0 : paymentDueComplete2,
                terminationDate:
                  paymentTermination2 === undefined ? " " : paymentTermination2,
              });
            }

            setdueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment Complete
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          min="0"
          max="100"
          type="number"
          placeholder=""
          value={
            paymentDueComplete2 === null || paymentDueComplete2 === undefined
              ? null
              : paymentDueComplete2 > 100
              ? 100
              : paymentDueComplete2 < 0
              ? 0
              : paymentDueComplete2
          }
          onChange={(e) => {
            setpaymentDueComplete2(Number(e.target.value));
            if (dueDates.length >= 2) {
              dueDatesArr = dueDates;
              dueDatesArr[1].paymentComplete = Number(
                e.target.value > 100
                  ? 100
                  : e.target.value < 0
                  ? 0
                  : e.target.value
              );
            } else {
              dueDatesArr.push(dueDates[0], {
                paymentDueDate: paymentDueDates2,
                paymentComplete: Number(
                  e.target.value > 100
                    ? 100
                    : e.target.value < 0
                    ? 0
                    : e.target.value
                ),
                terminationDate:
                  paymentTermination2 === undefined ? " " : paymentTermination2,
              });
            }

            setdueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Terminate date 2
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={paymentTermination2 === null ? " " : paymentTermination2}
          onChange={(e) => {
            setpaymentTermination2(e.target.value);
            if (dueDates.length >= 2) {
              dueDatesArr = dueDates;
              dueDatesArr[1].terminationDate = e.target.value;
            } else {
              dueDatesArr.push(dueDates[0], {
                paymentDueDate:
                  paymentDueDates2 === undefined ? " " : paymentDueDates2,
                paymentComplete:
                  paymentDueComplete2 === undefined ? 0 : paymentDueComplete2,
                terminationDate: e.target.value,
              });
            }

            setdueDates(dueDatesArr);
          }}
        />
      </CCol>
    </CRow>
  );
  let three = (
    <CRow className="mb-3">
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment due date 3
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={paymentDueDates3 === null ? " " : paymentDueDates3}
          onChange={(e) => {
            setpaymentDueDates3(e.target.value);
            if (dueDates.length >= 3) {
              dueDatesArr = dueDates;
              dueDatesArr[2].paymentDueDate = e.target.value;
            } else {
              dueDatesArr.push(dueDates[0], dueDates[1], {
                paymentDueDate: e.target.value,
                paymentComplete:
                  paymentDueComplete3 === undefined ? 0 : paymentDueComplete3,
                terminationDate:
                  paymentTermination3 === undefined ? " " : paymentTermination3,
              });
            }
            setdueDates(dueDatesArr);
            // setdueDates([paymentDueDates1, paymentDueDates2, paymentDueDates3]);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment Complete
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          min="0"
          max="100"
          type="number"
          placeholder=""
          value={
            paymentDueComplete3 === null || paymentDueComplete3 === undefined
              ? null
              : paymentDueComplete3 > 100
              ? 100
              : paymentDueComplete3 < 0
              ? 0
              : paymentDueComplete3
          }
          onChange={(e) => {
            setpaymentDueComplete3(Number(e.target.value));
            if (dueDates.length >= 3) {
              dueDatesArr = dueDates;
              dueDatesArr[2].paymentComplete = Number(
                e.target.value > 100
                  ? 100
                  : e.target.value < 0
                  ? 0
                  : e.target.value
              );
            } else {
              dueDatesArr.push(dueDates[0], dueDates[1], {
                paymentDueDate: paymentDueDates3,
                paymentComplete: Number(
                  e.target.value > 100
                    ? 100
                    : e.target.value < 0
                    ? 0
                    : e.target.value
                ),
                terminationDate:
                  paymentTermination3 === undefined ? " " : paymentTermination3,
              });
            }
            setdueDates(dueDatesArr);
            // setdueDates([paymentDueDates1, paymentDueDates2, paymentDueDates3]);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Terminate date 3
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={paymentTermination3 === null ? " " : paymentTermination3}
          onChange={(e) => {
            setpaymentTermination3(e.target.value);
            if (dueDates.length >= 3) {
              dueDatesArr = dueDates;
              dueDatesArr[2].terminationDate = e.target.value;
            } else {
              dueDatesArr.push(dueDates[0], dueDates[1], {
                paymentDueDate:
                  paymentDueDates3 === undefined ? " " : paymentDueDates3,
                paymentComplete:
                  paymentDueComplete3 === undefined ? 0 : paymentDueComplete3,
                terminationDate: e.target.value,
              });
            }
            setdueDates(dueDatesArr);
            // setdueDates([paymentDueDates1, paymentDueDates2, paymentDueDates3]);
          }}
        />
      </CCol>
    </CRow>
  );
  let four = (
    <CRow className="mb-3">
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment due date 4
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={paymentDueDates4 === null ? " " : paymentDueDates4}
          onChange={(e) => {
            setpaymentDueDates4(e.target.value);
            if (dueDates.length >= 4) {
              dueDatesArr = dueDates;
              dueDatesArr[3].paymentDueDate = e.target.value;
            } else {
              dueDatesArr.push(dueDates[0], dueDates[1], dueDates[2], {
                paymentDueDate: e.target.value,
                paymentComplete:
                  paymentDueComplete4 === undefined ? 0 : paymentDueComplete4,
                terminationDate:
                  paymentTermination4 === undefined ? " " : paymentTermination4,
              });
            }
            setdueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment Complete
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          min="0"
          max="100"
          type="number"
          placeholder=""
          value={
            paymentDueComplete4 === null || paymentDueComplete4 === undefined
              ? null
              : paymentDueComplete4 > 100
              ? 100
              : paymentDueComplete4 < 0
              ? 0
              : paymentDueComplete4
          }
          onChange={(e) => {
            setpaymentDueComplete4(Number(e.target.value));
            if (dueDates.length >= 4) {
              dueDatesArr = dueDates;
              dueDatesArr[3].paymentComplete = Number(
                e.target.value > 100
                  ? 100
                  : e.target.value < 0
                  ? 0
                  : e.target.value
              );
            } else {
              dueDatesArr.push(dueDates[0], dueDates[1], dueDates[2], {
                paymentDueDate: paymentDueDates4,
                paymentComplete: Number(
                  e.target.value > 100
                    ? 100
                    : e.target.value < 0
                    ? 0
                    : e.target.value
                ),
                terminationDate:
                  paymentTermination4 === undefined ? " " : paymentTermination4,
              });
            }
            setdueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Terminate date 4
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={paymentTermination4 === null ? " " : paymentTermination4}
          onChange={(e) => {
            setpaymentTermination4(e.target.value);
            if (dueDates.length >= 4) {
              dueDatesArr = dueDates;
              dueDatesArr[3].terminationDate = e.target.value;
            } else {
              dueDatesArr.push(dueDates[0], dueDates[1], dueDates[2], {
                paymentDueDate:
                  paymentDueDates4 === undefined ? " " : paymentDueDates4,
                paymentComplete:
                  paymentDueComplete4 === undefined ? 0 : paymentDueComplete4,
                terminationDate: e.target.value,
              });
            }
            setdueDates(dueDatesArr);
          }}
        />
      </CCol>
    </CRow>
  );
  let five = (
    <CRow className="mb-3">
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment due date 5
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={paymentDueDates5 === null ? " " : paymentDueDates5}
          onChange={(e) => {
            setpaymentDueDates5(e.target.value);
            if (dueDates.length === 5) {
              dueDatesArr = dueDates;
              dueDatesArr[4].paymentDueDate = e.target.value;
            } else {
              dueDatesArr.push(
                dueDates[0],
                dueDates[1],
                dueDates[2],
                dueDates[3],
                {
                  paymentDueDate: e.target.value,
                  paymentComplete:
                    paymentDueComplete5 === undefined ? 0 : paymentDueComplete5,
                  terminationDate:
                    paymentTermination5 === undefined
                      ? " "
                      : paymentTermination5,
                }
              );
            }
            setdueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel
          htmlFor="formFile validationCustom05"
          className="col-sm-12 col-form-label"
        >
          Payment Complete
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          min="0"
          max="100"
          type="number"
          placeholder=""
          value={
            paymentDueComplete5 === null || paymentDueComplete5 === undefined
              ? null
              : paymentDueComplete5 > 100
              ? 100
              : paymentDueComplete5 < 0
              ? 0
              : paymentDueComplete5
          }
          onChange={(e) => {
            setpaymentDueComplete5(Number(e.target.value));
            if (dueDates.length === 5) {
              dueDatesArr = dueDates;
              dueDatesArr[4].paymentComplete = Number(
                e.target.value > 100
                  ? 100
                  : e.target.value < 0
                  ? 0
                  : e.target.value
              );
            } else {
              dueDatesArr.push(
                dueDates[0],
                dueDates[1],
                dueDates[2],
                dueDates[3],
                {
                  paymentDueDate: paymentDueDates5,
                  paymentComplete: Number(
                    e.target.value > 100
                      ? 100
                      : e.target.value < 0
                      ? 0
                      : e.target.value
                  ),
                  terminationDate:
                    paymentTermination5 === undefined
                      ? " "
                      : paymentTermination5,
                }
              );
            }
            setdueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Terminate date 5
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={paymentTermination5 === null ? " " : paymentTermination5}
          onChange={(e) => {
            setpaymentTermination5(e.target.value);
            if (dueDates.length === 5) {
              dueDatesArr = dueDates;
              dueDatesArr[4].terminationDate = e.target.value;
            } else {
              dueDatesArr.push(
                dueDates[0],
                dueDates[1],
                dueDates[2],
                dueDates[3],
                {
                  paymentDueDate:
                    paymentDueDates5 === undefined ? " " : paymentDueDates5,
                  paymentComplete:
                    paymentDueComplete5 === undefined ? 0 : paymentDueComplete5,
                  terminationDate: e.target.value,
                }
              );
            }
            setdueDates(dueDatesArr);
          }}
        />
      </CCol>
    </CRow>
  );

  return (
    <>
      <CCardHeader className="mb-3">
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3>Add Tender</h3>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CForm onSubmit={postDisctData}>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom02"
                className="col-sm-12 col-form-label"
              >
                Tender Number:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                required
                type="text"
                placeholder=""
                value={tenderNo}
                id="validationCustom02"
                onChange={(e) => settenderNo(e.target.value)}
                invalid={tenderNo === "" ? true : false}
              />
              <CInvalidFeedback className="validationCustom02">
                Please Enter Tender Number
              </CInvalidFeedback>
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Details
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                placeholder=""
                value={details}
                id="validationCustom03"
                onChange={(e) => setdetails(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Publish Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={purchaseDate === null ? " " : purchaseDate}
                onChange={(e) => {
                  setpurchaseDate(e.target.value);
                }}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Payment Slots
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CSelect
                aria-label="Default select example"
                onChange={(e) => setpaymentSlots(e.target.value)}
              >
                <option>Select Slots</option>
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
              </CSelect>
            </CCol>
          </CRow>
          {parseInt(paymentSlots) === 1 ? (
            <>{one}</>
          ) : parseInt(paymentSlots) === 5 ? (
            <>
              {one}
              {two}
              {three}
              {four}
              {five}
            </>
          ) : parseInt(paymentSlots) === 2 ? (
            <>
              {one}
              {two}
            </>
          ) : parseInt(paymentSlots) === 3 ? (
            <>
              {one}
              {two}
              {three}
            </>
          ) : parseInt(paymentSlots) === 4 ? (
            <>
              {one}
              {two}
              {three}
              {four}
            </>
          ) : (
            ""
          )}
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Rebate
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder=""
                value={rebate}
                id="validationCustom03"
                onChange={(e) => setrebate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Late Fee Per Day
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder=""
                value={lateFeePerDay}
                id="validationCustom03"
                onChange={(e) => setlateFeePerDay(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Security Deposit Amount
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder=""
                value={securityDepositAmount}
                id="validationCustom03"
                onChange={(e) => setsecurityDepositAmount(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Security Deposit Day
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder=""
                value={securityDepositDay}
                id="validationCustom03"
                onChange={(e) => setsecurityDepositDay(e.target.value)}
              />
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Collection Season
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CSelect
                value={collectionSeason}
                id="validationCustom03"
                onChange={(e) => setcollectionSeason(e.target.value)}
              >
                {Array.from(new Array(200), (v, i) => (
                  <option key={i} value={year + i}>
                    {year + i}
                  </option>
                ))}
              </CSelect>
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Lease Period Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={leasePeriodDate}
                id="validationCustom03"
                onChange={(e) => setleasePeriodDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol xl={2}>
              <CLabel
                value={TenderType}
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Tender Type
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CSelect
                aria-label="Default select example"
                onChange={(e) => setTenderTypes(e.target.value)}
              >
                <option value={0} selected={true}>
                  Select Tender Type
                </option>
                <option value={1}>Advanced Tender</option>
                <option value={2}>Godown Tender</option>
                <option value={3}>MSP</option>
              </CSelect>
            </CCol>
          </CRow>

          <hr />

          <CRow xl={12} className="pt-3 ">
            <CCol xl={10}>
              <h3>Agreement Details</h3>
            </CCol>
          </CRow>
          <hr />
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom20"
                className="col-sm-12 col-form-label"
              >
                Period Ending Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={periodEndingDate}
                id="validationCustom20"
                onChange={(e) => setperiodEndingDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom21"
                className="col-sm-12 col-form-label"
              >
                Representative Details Submission Last Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={representativeDetailsLastDate}
                id="validationCustom21"
                onChange={(e) =>
                  setrepresentativeDetailsLastDate(e.target.value)
                }
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom04"
                className="col-sm-12 col-form-label"
              >
                Agreement Start Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={AgreementStartDate}
                id="validationCustom04"
                onChange={(e) => setAgreementStartDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom04"
                className="col-sm-12 col-form-label"
              >
                Agreement Upto Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={AgreementUptoDate}
                id="validationCustom04"
                onChange={(e) => setAgreementUptoDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom22"
                className="col-sm-12 col-form-label"
              >
                Distt Union Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={paymentLastDate}
                id="validationCustom22"
                onChange={(e) => setpaymentLastDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom23"
                className="col-sm-12 col-form-label"
              >
                Double Lock Upto Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={doubleLockUptoDate}
                id="validationCustom23"
                onChange={(e) => setdoubleLockUptoDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom24"
                className="col-sm-12 col-form-label"
              >
                Through Letter Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={throughLetterDate}
                id="validationCustom24"
                onChange={(e) => setthroughLetterDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom25"
                className="col-sm-12 col-form-label"
              >
                Keeping In Godown Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={keepingInGodownDate}
                id="validationCustom25"
                onChange={(e) => setkeepingInGodownDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom04"
                className="col-sm-12 col-form-label"
              >
                Godown Insurace Date From
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={godownInsuraceFromDate}
                id="validationCustom04"
                onChange={(e) => setGodownInsuraceFromDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom04"
                className="col-sm-12 col-form-label"
              >
                Godown Insurace Date To
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={godownInsuraceToDate}
                id="validationCustom04"
                onChange={(e) => setGodownInsuraceToDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className=" mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom05"
                className="col-sm-12 col-form-label"
              >
                Last Date For Submitting Insurance Policy
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={lastDateForSubmittingInsurancePolicy}
                id="validationCustom05"
                onChange={(e) =>
                  setLastDateForSubmittingInsurancePolicy(e.target.value)
                }
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom06"
                className="col-sm-12 col-form-label"
              >
                Extra Amount Insurance LastDate
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={extraAmountInsuranceLastDate}
                id="validationCustom06"
                onChange={(e) =>
                  setExtraAmountInsuranceLastDate(e.target.value)
                }
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom07"
                className="col-sm-12 col-form-label"
              >
                Late Fee Insurance Amount
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                placeholder="0.00"
                value={lateFeeInsuranceAmount}
                id="validationCustom07"
                onChange={(e) => setLateFeeInsuranceAmount(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom08"
                className="col-sm-12 col-form-label"
              >
                Restoration Fee
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder="0"
                value={RestorationFee}
                id="validationCustom08"
                onChange={(e) => setRestorationFee(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom09"
                className="col-sm-12 col-form-label"
              >
                Penalty Amount
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder="0"
                value={penaltyAmount}
                id="validationCustom09"
                onChange={(e) => {
                  setPenaltyAmount(e.target.value);
                }}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom14"
                className="col-sm-12 col-form-label"
              >
                Termination Late Fee Per Day
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                placeholder="0.00"
                value={TerminationLateFeePerDay}
                id="validationCustom14"
                onChange={(e) => setTerminationLateFeePerDay(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom10"
                className="col-sm-12 col-form-label"
              >
                Termination Agreement Start Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={TerminationAgreementStartDate}
                id="validationCustom10"
                onChange={(e) =>
                  setTerminationAgreementStartDate(e.target.value)
                }
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom11"
                className="col-sm-12 col-form-label"
              >
                Termination Agreement End Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={TerminationAgreementEndDate}
                id="validationCustom11"
                onChange={(e) => setTerminationAgreementEndDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom12"
                className="col-sm-12 col-form-label"
              >
                After Termination Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={AfterTerminationDate}
                id="validationCustom12"
                onChange={(e) => setAfterTerminationDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom13"
                className="col-sm-12 col-form-label"
              >
                Termination UpTo Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={TerminationUpToDate}
                id="validationCustom13"
                onChange={(e) => setTerminationUpToDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom15"
                className="col-sm-12 col-form-label"
              >
                Pruning Start Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={PruningStartDate}
                id="validationCustom15"
                onChange={(e) => setPruningStartDate(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom16"
                className="col-sm-12 col-form-label"
              >
                Pruning End Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={PruningEndDate}
                id="validationCustom16"
                onChange={(e) => setPruningEndDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom26"
                className="col-sm-12 col-form-label"
              >
                Godown Rent Payment Upto Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={godownRentPaymentUptoDate}
                id="validationCustom26"
                onChange={(e) => setgodownRentPaymentUptoDate(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom27"
                className="col-sm-12 col-form-label"
              >
                Second Agreement Extension Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={secondAgreementExtentionDate}
                id="validationCustom27"
                onChange={(e) =>
                  setsecondAgreementExtentionDate(e.target.value)
                }
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom28"
                className="col-sm-12 col-form-label"
              >
                Additional SD Last Date:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={additionalSDLastDate}
                id="validationCustom28"
                onChange={(e) => setadditionalSDLastDate(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom29"
                className="col-sm-12 col-form-label"
              >
                GoDown Rent per Bag
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder="0"
                value={godownRentPerBag}
                id="validationCustom29"
                onChange={(e) => setGodownRentPerBag(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom30"
                className="col-sm-12 col-form-label"
              >
                HSN:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                maxLength={100}
                placeholder=""
                value={HSN}
                id="validationCustom30"
                onChange={(e) => setHSN(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom31"
                className="col-sm-12 col-form-label"
              >
                Cheque Replacement Last Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={ChequeReplacementLastDate}
                id="validationCustom31"
                onChange={(e) => setChequeReplacementLastDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom32"
                className="col-sm-12 col-form-label"
              >
                First Transfer Last Date:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={FirstTransferLastDate}
                id="validationCustom32"
                onChange={(e) => setFirstTransferLastDate(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom33"
                className="col-sm-12 col-form-label"
              >
                Second Transfer Start Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={SecondTransferStartDate}
                id="validationCustom33"
                onChange={(e) => setSecondTransferStartDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom34"
                className="col-sm-12 col-form-label"
              >
                Second Transfer End Date:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={SecondTransferEndDate}
                id="validationCustom34"
                onChange={(e) => setSecondTransferEndDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <hr />

          <CRow xl={12} className="pt-3 ">
            <CCol xl={10}>
              <h3>Sanction Details</h3>
            </CCol>
          </CRow>
          <hr />
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Clause
              </CLabel>
            </CCol>

            <CCol xl={4}>
              <span>{`Lease period upto {{Lease Period date will appear here}}`}</span>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}></CCol>{" "}
            <CCol xl={6}>
              <span>{`The due dates of the payment of instalments are {{Payment Installment date will appear here}}.`}</span>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}></CCol>{" "}
            <CCol xl={4}>
              <CTextarea
                rows="2"
                value={clauseData === null ? "" : clauseData}
                onChange={(e) => {
                  setclauseData(e.target.value);
                }}
              />
            </CCol>
            <CCol xl={2}>
              <CButton
                onClick={() => {
                  console.log(clauseSlots);
                  let click = clauseSlots;
                  setclauseSlots(click + 1);
                  if (clauseId.length === 0) {
                    const newclause = [
                      ...clausesData,
                      { id: click + 1, clause: "" },
                    ];
                    setclauseId([...clauseId, click + 1]);
                    console.log("clauseId", ...clauseId);
                    setclausesData(newclause);
                  } else {
                    const newclause = [
                      ...clausesData,
                      { id: clauseId[clauseId.length - 1] + 1, clause: "" },
                    ];
                    setclauseId([
                      ...clauseId,
                      clauseId[clauseId.length - 1] + 1,
                    ]);
                    console.log("clauseId", ...clauseId);
                    setclausesData(newclause);
                  }
                }}
                color="success"
              >
                +
              </CButton>
            </CCol>
            {console.log(clausesData)}
            {console.log("clauseSlots", clauseSlots)}
          </CRow>
          {[...Array(clausesData.length)].map((e, i) => (
            <>
              {console.log("i", i)}
              {console.log("clauseId", clauseId)}

              <CRow className="mb-3">
                <CCol xl={2}></CCol>
                <CCol xl={4}>
                  <CTextarea
                    rows="2"
                    key={`key-input ${i}`}
                    value={
                      clausesData[i].clause === null
                        ? ""
                        : clausesData[i].clause
                    }
                    onChange={(e) => {
                      setclausesData((prev) =>
                        prev.map((item) =>
                          item.id === clauseId[i]
                            ? { id: clauseId[i], clause: e.target.value }
                            : item
                        )
                      );
                    }}
                  />
                </CCol>
                <CCol xl={1}>
                  <CButton
                    color="danger"
                    onClick={(e) => {
                      if (clausesData.length === 1) {
                        setclausesData([]);
                        setclauseId([]);
                        setclauseSlots(1);
                      } else {
                        const removedArr = [...clausesData].filter(
                          (clause) => clause.id !== clauseId[i]
                        );
                        setclausesData(removedArr);
                        const removedId = [...clauseId].filter(
                          (id) => id !== clauseId[i]
                        );
                        setclauseId(removedId);
                        setclauseSlots(clauseSlots - 1);
                      }
                    }}
                  >
                    -
                  </CButton>
                </CCol>
              </CRow>
            </>
          ))}
          <CRow className="mb-3">
            <CCol xl={2}>
              {loading ? (
                <CSpinner className="spinner-grow" color="success" />
              ) : (
                <div>
                  <CButton className="ml-3" color="success" type="submit">
                    Add
                  </CButton>
                  <CButton
                    className="ml-3"
                    color="danger"
                    to={
                      authenticated.role === "CGMF"
                        ? "/tender/tenderlist"
                        : "/tenderlist"
                    }
                  >
                    Cancel
                  </CButton>
                </div>
              )}
            </CCol>
          </CRow>
        </CForm>
      </CCardBody>
    </>
  );
};
export default AddTender;
